var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "42px",
    viewBox: "0 0 32 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12DA7587-204B-4B79-9079-FFAE3BB72C13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-946.000000, -149.000000)",
    fill: "#E71037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-password",
    transform: "translate(946.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,42 L4,42 C1.79555556,42 0,40.3183333 0,38.25 L0,20.75 C0,18.6816667 1.79555556,17 4,17 L28,17 C30.2044444,17 32,18.6816667 32,20.75 L32,38.25 C32,40.3183333 30.2044444,42 28,42 Z M4,19.5 C3.26577778,19.5 2.66666667,20.06 2.66666667,20.75 L2.66666667,38.25 C2.66666667,38.94 3.26577778,39.5 4,39.5 L28,39.5 C28.7342222,39.5 29.3333333,38.94 29.3333333,38.25 L29.3333333,20.75 C29.3333333,20.06 28.7342222,19.5 28,19.5 L4,19.5 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8125,18 C23.157,18 22.625,17.424 22.625,16.7142857 L22.625,10.2857143 C22.625,6.03257143 19.42825,2.57142857 15.5,2.57142857 C11.57175,2.57142857 8.375,6.03257143 8.375,10.2857143 L8.375,16.7142857 C8.375,17.424 7.843,18 7.1875,18 C6.532,18 6,17.424 6,16.7142857 L6,10.2857143 C6,4.61314286 10.26075,0 15.5,0 C20.73925,0 25,4.61314286 25,10.2857143 L25,16.7142857 C25,17.424 24.468,18 23.8125,18 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,32 C12.794,32 11,30.206 11,28 C11,25.794 12.794,24 15,24 C17.206,24 19,25.794 19,28 C19,30.206 17.206,32 15,32 Z M15,27 C14.45,27 14,27.448 14,28 C14,28.552 14.45,29 15,29 C15.55,29 16,28.552 16,28 C16,27.448 15.55,27 15,27 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,36 C14.448,36 14,35.5256471 14,34.9411765 L14,31.0588235 C14,30.4743529 14.448,30 15,30 C15.552,30 16,30.4743529 16,31.0588235 L16,34.9411765 C16,35.5256471 15.552,36 15,36 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.f59fc09566214ac2a3219f02cd999d5b.svg";
export { ForwardRef as ReactComponent };